import setupAxios from './Base'
const prefix = '/_api_'

const axios = setupAxios()

export default class Onboarding {
  constructor(token) {
    this.wedId = token.token_payload.wed_id
    axios.defaults.headers.common['Authorization'] = `Bearer ${token.token}`
  }

  getUrlAvailable(urlWedding) {
    return axios
      .get(`${prefix}/validateSiteUrl?wed=${this.wedId}&url=${urlWedding}`)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response.data
      })
  }

  saveOnboarding(data) {
    return axios
      .post(`${prefix}/saveOnboarding?wed=${this.wedId}`, data)
      .then((response) => response.data)
      .catch(() => false)
  }
}
